<template>
<div>
     <keep-alive>
        <component  v-bind:is="currentView" :dataList="option.dataList" ></component>
    </keep-alive>
</div>       
</template>
<script>
export default {
  name: 'componentView',
  props: {
     option: { 
      type: Object,
      default: () =>{
         return {
           dataList: [],
           componentType:'noImgList'
         } 
      }
     }
  },
   data () {
     return {
        currentData: this.option.dataList
     }
   },
   created(){
        // console.log(this.option.dataList)
   },
   computed: {
          currentView() {
            return require(`../components/${this.option.componentType}`).default
          }
   }
}
</script>



// WEBPACK FOOTER //
// src/components/componentView.vue